// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "agree-dvfV7";
export { _1 as "__esModule", _2 as "agree" }
export default { "__esModule": _1, "agree": _2 }
